<template>
    <div v-if="$store.state.jwtClaims.isAdmin">
        <headful
            title="Caseen - Admin Control Panel"
        />        
        <h1>Admin Control Panel</h1>
        <md-tabs md-sync-route>
            <md-tab md-label="User List" to="/admin/" exact>
                <h2>
                    User List:
                </h2>
                <div style="width: 100%; height: 500px; max-height: 75vh; overflow: auto;">
                    <br>
                    <md-table v-model="userList" md-sort="name" md-sort-order="asc" md-card>
                        <!--<md-table-toolbar>
                            <div class="md-toolbar-section-start">
                            </div>
                            <md-field md-clearable class="md-toolbar-section-end">
                            <md-input placeholder="Search by name..." v-model="search" @input="searchOnTable" />
                            </md-field>
                        </md-table-toolbar>

                        <md-table-empty-state
                            md-label="No users found"
                            :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
                        </md-table-empty-state>-->

                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Username" md-sort-by="uname"><a target="_blank" :href="'user/' + item.id">{{item.uname}}</a></md-table-cell>
                            <md-table-cell md-label="Full Name" md-sort-by="fullName">{{item.fullName}}</md-table-cell>
                            <md-table-cell md-label="Email" md-sort-by="email">{{item.email}}</md-table-cell>
                            <md-table-cell md-label="Authentication" md-sort-by="authProvider">{{item.authProvider}}</md-table-cell>
                            <md-table-cell md-label="Educator" md-sort-by="isEducator">{{item.isEducator}}</md-table-cell>
                            <md-table-cell md-label="Premium" md-sort-by="isPremium">{{item.isPremium}}</md-table-cell>
                            <md-table-cell md-label="Admin" md-sort-by="isAdmin">{{item.isAdmin}}</md-table-cell>
                            <md-table-cell md-label="Accepted TOS" md-sort-by="acceptedTOS">{{item.acceptedTOS}}</md-table-cell>
                            <md-table-cell md-label="Date Joined" md-sort-by="dateJoinedSortable">{{item.dateJoined}}</md-table-cell>
                        </md-table-row>
                    </md-table>
                </div>
            </md-tab>
            <md-tab md-label="Case Import" to="/admin/caseimport">
                <CaseImport></CaseImport>
            </md-tab>
        </md-tabs>
    </div>
</template>
<script>
    import CaseImport from "./CaseImport.vue"
    import APIRequests from "../APIRequests.js"

    import ObjectID  from "bson-objectid"
    
    export default {
        components: {
            CaseImport,
        },
        data: function(){
            return {
                userList: []
            }
        },
        methods: {
            fetchUserList: function(){
                return new Promise((resolve, reject) => {
                    let api_url = this.$store.state.api_url + "/api/users/list"
                    APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                        if(!data){
                            data = []
                        }
                        let pad = function(n) {
                            return (n < 10) ? ("0" + n) : n;
                        }
                        this.userList = data.map((entry) => {
                            entry.isEducator = entry.isEducator.toString()
                            entry.isPremium = entry.isPremium.toString()
                            entry.isAdmin = entry.isAdmin.toString()
                            entry.acceptedTOS = entry.acceptedTOS.toString()
                            let t = ObjectID(entry.id).getTimestamp();
                            entry.dateJoinedSortable = t.getFullYear()  + " " + pad(t.getMonth() + 1) + " " + pad(t.getDate())
                            entry.dateJoined = (t.getMonth() + 1) + "-" + t.getDate() + "-" + t.getFullYear()
                            return entry
                        });
                        this.serverError = undefined;
                        resolve()
                    }).catch(([xhrStatus, xhrResp]) => {
                        this.serverError = xhrStatus
                        reject([xhrStatus, xhrResp])
                    })
                })
            },
        },
        mounted: function(){
            this.$nextTick(function () {
                setTimeout(this.fetchUserList, 250)
            })
        }
    }
</script>

<style>
    .md-table-head-label{
        width: 100%;
        text-align: center;
    }
</style>
